/*
 * @Author: Gexiaolei gxiaolei@163.com
 * @Date: 2022-12-01 14:54:03
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @LastEditTime: 2022-12-02 13:48:48
 * @FilePath: /fe-mall/pages/index/src/routes/pr-paas/components/reassignment-dialog/api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const project = window.fe.project
export default {
  transferRecord: {
    type: 'post',
    url: `${project}/apply/record/applyOperateRecord`
  }
}
